import React from 'react';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';

const Navbars = () => {
    return (
        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" className='bg-dark bg-gradient fixed-top p-3'>
            <Container>
                <Navbar.Brand href='home#banner' style={{ cursor: 'pointer' }}>Md. Saimon Sikder Srayo</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link href='home#banner'>Home</Nav.Link>
                        <Nav.Link href="home#skills">Skills</Nav.Link>
                        <Nav.Link href="home#projects">Projects</Nav.Link>
                        <Nav.Link href="home#services">Services</Nav.Link>
                        <Nav.Link href="home#about">About</Nav.Link>
                        <Nav.Link href="home#contact">Contact</Nav.Link>
                        <a href="https://drive.google.com/file/d/1deZmMtuYJz2kLf1ylQgkj-hAQ9yMRjva/view?usp=sharing" target='_blank' rel="noreferrer"><Button variant="info" className='ms-0 ms-lg-2 mt-2 mt-lg-0 btn-glow-2'>Resume</Button></a>

                    </Nav>

                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Navbars;